module.exports = __webpack_public_path__ + "a04cc4f76f99066265a65298e3ab8a8e.webm";